import { render, staticRenderFns } from "./BotpressChatWidget.vue?vue&type=template&id=2abe18b1&scoped=true"
import script from "./BotpressChatWidget.vue?vue&type=script&lang=js"
export * from "./BotpressChatWidget.vue?vue&type=script&lang=js"
import style0 from "./BotpressChatWidget.vue?vue&type=style&index=0&id=2abe18b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe18b1",
  null
  
)

export default component.exports